<template>
  <div>
    <div class="container">
      <div class="section breadcrumb" >
        <div class="header-wrapper">
            <div class="pb-title">MY RESOURCE CENTRE</div>
        </div>
      </div>
    </div>
    <!-- Content -->
    <div class="container mb-6">

      <!-- searchbar desktop -->
      <div class="columns is-12 is-desktop is-multiline is-hidden-touch">
        <div class="column is-2-desktop">
        </div>
        <div class="column is-10-desktop">
          <div class="section py-3">
            <div class="searchBar my-4">
              <b-autocomplete
                  class="column is-12 p-0 "
                  v-model="searchInput"
                  :data="filteredDataArray"
                  placeholder="Search by keyword"
                  icon-right="magnify"
                  clearable
                  @typing="filterResourceCentre('typing')"
                  @select="filterResourceCentre('select')">
                  <template #empty>No results found</template>
              </b-autocomplete>
            </div>
            <div class="" >
              
            </div>
          </div>
        </div>
      </div>


      <!-- searchbar mobile -->
      <div class="is-hidden-desktop">
        <div class="section py-3">
          <div class="searchBar my-4 " style="position: relative;">
            <b-autocomplete
                class="column is-12 p-0 "
                v-model="searchInput"
                :data="filteredDataArray"
                placeholder="Search by keyword"
                icon-right="magnify"
                clearable
                @focus="filterResourceCentre('click')"
                @typing="filterResourceCentre('typing')"
                @select="filterResourceCentre('select')">
                <template #empty>No results found</template>
                
            </b-autocomplete>
            <img v-if="!showCategoryMobile" class="category-icon-list" @click="showCategoryMobile = true" src="../../../assets/icons/list.svg"/>
            <img v-else class="category-icon-list" @click="showCategoryMobile = false" src="../../../assets/icons/list-colored.svg"/>
          </div>
          <div v-show="showCategoryMobile" class="dropdown-category-mobile sidebar-wrapper">
            <div :class="$route.query.category == 'Guide' ? 'item-sidebar active' : 'item-sidebar' " @click="sidebarHandler('Guide')">Guide</div>
            <div :class="$route.query.category == 'Forms' ? 'item-sidebar active' : 'item-sidebar' " @click="sidebarHandler('Forms')">Forms</div>
            <div :class="$route.query.category == 'Video' ? 'item-sidebar active' : 'item-sidebar' " @click="sidebarHandler('Video')">Video</div>
            <div :class="$route.query.category == 'Weekly-Review' ? 'item-sidebar active' : 'item-sidebar' " @click="sidebarHandler('Weekly-Review')">Weekly Review</div>
            <div :class="$route.query.category == 'Announcement' ? 'item-sidebar active' : 'item-sidebar' " @click="sidebarHandler('Announcement')">Announcement</div>
            <div :class="$route.query.category == 'Fund-Update' ? 'item-sidebar active' : 'item-sidebar' " @click="sidebarHandler('Fund-Update')">Fund Update</div>
            <div :class="$route.query.category == 'Agency-Circular' ? 'item-sidebar active' : 'item-sidebar' " @click="sidebarHandler('Agency-Circular')">Agency Circular</div>
          </div>
        </div>
      </div>


      <div class="columns is-12 is-mobile is-tablet is-desktop is-multiline">
        <div class="column is-2-desktop is-hidden-touch">
          <div class="sidebar-wrapper">
            <div :class="$route.query.category == 'Guide' ? 'item-sidebar active' : 'item-sidebar' " @click="sidebarHandler('Guide')">Guide</div>
            <div :class="$route.query.category == 'Forms' ? 'item-sidebar active' : 'item-sidebar' " @click="sidebarHandler('Forms')">Forms</div>
            <div :class="$route.query.category == 'Video' ? 'item-sidebar active' : 'item-sidebar' " @click="sidebarHandler('Video')">Video</div>
            <div :class="$route.query.category == 'Weekly-Review' ? 'item-sidebar active' : 'item-sidebar' " @click="sidebarHandler('Weekly-Review')">Weekly Review</div>
            <div :class="$route.query.category == 'Announcement' ? 'item-sidebar active' : 'item-sidebar' " @click="sidebarHandler('Announcement')">Announcement</div>
            <div :class="$route.query.category == 'Fund-Update' ? 'item-sidebar active' : 'item-sidebar' " @click="sidebarHandler('Fund-Update')">Fund Update</div>
            <div :class="$route.query.category == 'Agency-Circular' ? 'item-sidebar active' : 'item-sidebar' " @click="sidebarHandler('Agency-Circular')">Agency Circular</div>
          </div>
        </div>
        <div class="column is-10-desktop is-12-tablet is-12-mobile">
          <div class="content">
            <div class="is-flex count-wrap mr-3 pb-3" style="border-bottom: 1px solid #C4C4C4">
              <div class="is-flex is-align-items-center">
                <b-icon icon="magnify"></b-icon> 
                <span class="ml-1 mr-2">All</span>
                <span class="colour-primary-02">{{ totalDataLength }}</span>
              </div>
              <div class="is-flex is-align-items-center ml-3">
                <b-icon icon="file-link-outline"></b-icon> 
                <span class="ml-1 mr-2">Files</span>
                <span class="colour-primary-02">{{ filesNum }}</span>
              </div>
              <div class="is-flex is-align-items-center ml-3">
                <b-icon icon="video-outline"></b-icon> 
                <span class="ml-1 mr-2">Videos</span>
                <span class="colour-primary-02">{{ videosNum }}</span>
              </div>
            </div>
            <div v-if="$route.query.category">
              <div class="pb-title my-5">
                {{  $route.query.category == 'Guide' ? "Guide" :
                    $route.query.category == 'Forms' ? "Forms" :
                    $route.query.category == 'Video' ? "Video" :
                    $route.query.category == 'Weekly-Review' ? "Weekly Review" :
                    $route.query.category == 'Announcement' ? "Announcement" :
                    $route.query.category == 'Fund-Update' ? "Fund Update" :
                    "Agency Circular" }}
              </div>
              <div v-if="$route.query.category == 'Forms'">
                <div class="colour-secondary-03 mt-5 mb-2">Forms Category Filter</div>
                <div class="is-flex is-flex-wrap-wrap">
                  <div v-for="(item,index) in subchildForms" :key="index" >
                    <div :class="'is-clickable pb-subtitle tag-box ' + (subFormActive == item.name ? 'active' : '') " @click="filterSubchildForms(item.name)" >{{ item.name }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="related-category">
              <div class="colour-secondary-03 mt-5 mb-2">Related Category</div>
              <div class="is-flex is-flex-wrap-wrap">
                <div v-for="(item,index) in relatedCategoryFiltered" :key="index" >
                  <div class="is-clickable pb-subtitle tag-box" @click="sidebarHandler((item.name).replace(' ', '-'))" >{{ item.name }}</div>
                </div>
              </div>
            </div>

            <!-- content desktop -->
            <div class="latest-topic is-hidden-touch">
              <div v-if="$route.query.category" class="colour-secondary-03 mt-5 mb-2">Search Results</div>
              <div v-else class="colour-secondary-03 mt-5 mb-2">Latest Topic</div>
              <b-loading :is-full-page="false" v-model="isLoading">
                  <b-icon
                      pack="mdi"
                      icon="loading"
                      size="is-large"
                      custom-class="mdi-spin">
                  </b-icon>
              </b-loading>
              <div v-if="totalData.length > 0" class="">
                <div v-for="(item, index) in totalData" :key="index" >
                  <div class="topic-card" >
                    <div class="is-flex pr-3"> 
                      <div class="mr-4 mt-1"><b-icon class="ml-1" :icon="item.attributes.category == 'Guide' ? 'play-box-outline' : item.attributes.category == 'Video' ?  'video-outline' : item.attributes.category == 'Forms' ? 'view-list-outline ' : item.attributes.category == 'Weekly Review' ? 'chart-box-outline' : item.attributes.category == 'Announcement' ? 'text-box-outline' : item.attributes.category == 'Fund Update' ? 'cash ' : item.attributes.category == 'Agency Circular' ? 'account-box-outline' : ''" ></b-icon></div>
                      <div>
                        <div class="pb-title-3">{{ item.attributes.title }}</div>
                        <div class="is-flex pb-subtitle-3 colour-secondary-03" >
                          {{ item.attributes.category && item.attributes.category != 'Announcement' ? item.attributes.category : '' }} {{ item.attributes.subchildForms && item.attributes.category == 'Forms'  ? " | " +item.attributes.subchildForms : '' }}  {{ (item.attributes.subtitle && item.attributes.category == 'Announcement') ? item.attributes.subtitle : (item.attributes.subtitle && item.attributes.category != 'Announcement')  ? " | " +item.attributes.subtitle : '' }}
                        </div>
                        <!-- <div class="pb-subtitle-3 colour-secondary-03">{{ item.attributes.subtitle }}</div> -->
                      </div>
                    </div>
                    <div>
                      <div class="is-flex is-justify-content-end">
                        <div v-show="index == copyIndex" class="text-l14 colour-primary-02">{{ text }}</div>

                        <div style="cursor: copy;" v-if="item.attributes.link || (item.attributes.category == 'Weekly Review' || item.attributes.category == 'Announcement')" @click="copyLink(item.attributes.link, index, item.attributes.category, item.id)"><b-icon class="mx-3 colour-secondary-01" icon="link" ></b-icon></div>
                        <div style="cursor: not-allowed" v-else ><b-icon class="mx-3 colour-secondary-03" icon="link" ></b-icon></div>
                        
                        <b-button v-if="item.attributes.category == 'Forms' || item.attributes.category == 'Fund Update' || item.attributes.category == 'Agency Circular' || (item.attributes.category == 'Weekly Review' && item.attributes.link)"  class="is-clickable btn-download" @click="downloadForm(item.attributes.link)" size="is-small" style="border:none; background-color: transparent;">
                          <img src="../../../assets/icons/icon-download-colored.png"/>
                        </b-button>
                        <router-link v-else :to="{ name: item.attributes.category == 'Guide' ? 'training-details' : item.attributes.category == 'Video' ? 'video-details' : item.attributes.category == 'Weekly Review' ? 'weekly-market-review-id' : item.attributes.category == 'Announcement' ? 'announcement-details' : '' , params: { id: item.id} }"  ><b-icon class="ml-3 mb-1 colour-secondary-01" icon="arrow-top-right" ></b-icon></router-link>
                      </div>
                      <div class="is-flex is-justify-content-end colour-secondary-03" style="white-space: nowrap;">{{ item.attributes.date ? formatDate(item.attributes.date) : '' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <!-- content mobile -->
            <div class="latest-topic is-hidden-desktop">
              <div v-if="$route.query.category" class="colour-secondary-03 mt-5 mb-2">Search Results</div>
              <div v-else class="colour-secondary-03 mt-5 mb-2">Latest Topic</div>
              <b-loading :is-full-page="true" v-model="isLoading">
                  <b-icon
                      pack="mdi"
                      icon="loading"
                      size="is-large"
                      custom-class="mdi-spin">
                  </b-icon>
              </b-loading>
              <div v-if="totalData.length > 0" class="">
                <div v-for="(item, index) in totalData" :key="index" >
                  <div class="topic-card" >
                    <div class="is-flex"> 
                      <div class="mr-4 "><b-icon class="ml-1" :icon="item.attributes.category == 'Guide' ? 'play-box-outline' : item.attributes.category == 'Video' ?  'video-outline' : item.attributes.category == 'Forms' ? 'view-list-outline ' : item.attributes.category == 'Weekly Review' ? 'chart-box-outline' : item.attributes.category == 'Announcement' ? 'text-box-outline' : item.attributes.category == 'Fund Update' ? 'cash ' : item.attributes.category == 'Agency Circular' ? 'account-box-outline' : ''" ></b-icon></div>
                      <div>
                        <div class="pb-title-3">{{ item.attributes.title }}</div>
                        <div class="is-flex pb-subtitle-3 colour-secondary-03" >
                          {{ item.attributes.category && item.attributes.category != 'Announcement' ? item.attributes.category : '' }} {{ item.attributes.subchildForms && item.attributes.category == 'Forms'  ? " | " +item.attributes.subchildForms : '' }}  {{ (item.attributes.subtitle && item.attributes.category == 'Announcement') ? item.attributes.subtitle : (item.attributes.subtitle && item.attributes.category != 'Announcement')  ? " | " +item.attributes.subtitle : '' }}
                        </div>
                        <div>
                          <div class="is-flex colour-secondary-03 pb-subtitle-3 my-2" style="white-space: nowrap;">{{ item.attributes.date ? formatDate(item.attributes.date) : '' }}</div>
                          <div class="is-flex">
                            <div v-show="index == copyIndex" class="text-l14 colour-primary-02">{{ text }}</div>

                            <div style="cursor: copy;" v-if="item.attributes.link" @click="copyLink(item.attributes.link, index)"><b-icon class="mr-2 colour-secondary-01" icon="link" ></b-icon></div>
                            <div style="cursor: not-allowed" v-else ><b-icon class=" colour-secondary-03" icon="link" ></b-icon></div>
                            
                            <b-button v-if="item.attributes.category == 'Forms' || item.attributes.category == 'Fund Update' || item.attributes.category == 'Agency Circular' || (item.attributes.category == 'Weekly Review' && item.attributes.link)"  class="is-clickable btn-download" @click="downloadForm(item.attributes.link)" size="is-small" style="border:none; background-color: transparent;">
                              <img src="../../../assets/icons/icon-download-colored.png"/>
                            </b-button>
                            <router-link v-else :to="{ name: item.attributes.category == 'Guide' ? 'training-details' : item.attributes.category == 'Video' ? 'video-details' : item.attributes.category == 'Weekly Review' ? 'weekly-market-review-id' : item.attributes.category == 'Announcement' ? 'announcement-details' : '' , params: { id: item.id} }"  ><b-icon class="ml-3 mb-1 colour-secondary-01" icon="arrow-top-right" ></b-icon></router-link>
                          </div>
                        </div>
                          
                        <!-- <div class="pb-subtitle-3 colour-secondary-03">{{ item.attributes.subtitle }}</div> -->
                      </div>
                    </div>
                  
                  </div>
                </div>
              </div>
            </div>
          </div>
           <!-- PAGINATION -->
            <div class="pb-pagination" v-if="pagination.pageCount > 1 && totalDataLength > 5" >
              <b-pagination
                  :total="pagination.total"
                  v-model="current"
                  range-before="2"
                  range-after="2"
                  order="is-centered"
                  :per-page="pagination.pageSize"
                  icon-prev="menu-left"
                  icon-next="menu-right"
                  @change="updateContentByPage(current)">
              </b-pagination>
            </div>
        </div>
      </div>
    </div>

    
  </div>
</template>

<script>
  import dayjs from 'dayjs';
  import SearchBar from "../../../components/SearchBar.vue";
  import debounce from 'lodash/debounce';

  export default {
    components: { SearchBar },
    data() {
      return {
        text: 'Link Copied!',
        searchInput:'',
        showCategoryMobile: false,
        hideButton: false,
        dataLength: 0,
        counter: 0,
        categoryCurrent: null,
        currentPage: 1,
        current: 1,
        pagination: {},
        data: [],
        totalData: [],
        totalDataAllCat: [],
        totalDataLength: 0,
        totalDataTitleList: [],
        dataList: [],
        isLoading: false,
        copyIndex: null,
        searchInput: '',
        subFormActive: '',
        subchildForms: [
          {
            name: "Individual Investor"
          },
          {
            name: "Institutional Investor"
          },
          {
            name: "Other Forms"
          }
        ],
        relatedCategoryList: [
          {
            type: "training",
            name: "Guide"
          },
          {
            type: "fundamental",
            name: "Fundamental"
          },
          {
            type: "forms",
            name: "Forms"
          },
          {
            type: "videos",
            name: "Video"
          },
          {
            type: "weekly-review",
            name: "Weekly Review"
          },
          {
            type: "announcement",
            name: "Announcement"
          },
          {
            type: "fund-update",
            name: "Fund Update"
          },
          {
            type: "agency-circular",
            name: "Agency Circular"
          }
        ]
      };
    },
    async mounted() {
      const loadingComponent = this.$buefy.loading.open();
      window.scrollTo(0, 0);
      await this.$httpClientCMS({
        method: 'GET',
        url: 'api/my-resource-centres?populate=*&sort=date:desc'
      })
      .then(resp => {
        let totalArr = resp.data.data
        this.totalData = totalArr
        this.dataList = totalArr
        this.totalDataTitleList = totalArr.map(i => i.attributes.title);

        this.updateContentByPage(1)
        loadingComponent.close()
      })
      .catch((error) => {
        console.error(error)
        loadingComponent.close()
        this.$router.push('maintenance');
      });
    },
    computed: {
      sortedItems() {
        return (this.totalData).slice().sort( ( a, b) => {
          return new Date(a.date) - new Date(b.date)
        });
      },
      filteredDataArray() {
        return this.totalDataTitleList.filter((option) => {
          return option
            .toString()
            .toLowerCase()
            .indexOf(this.searchInput.toLowerCase()) >= 0
        })
      },
      filesNum() {
        var fileData = []
        if(this.$route.query.category) {
          fileData = this.dataList.filter((obj) => 
            (obj.attributes.category == (this.$route.query.category).replace('-', ' ') && obj.attributes.category != 'Video')  && obj.attributes.link
          )
        }
        else {
          fileData = this.dataList.filter((obj) => 
            obj.attributes.category != 'Video' && obj.attributes.link
          )
        }

        if(this.searchInput) {
          fileData = this.totalData.filter((obj) => 
            obj.attributes.title == this.searchInput
          )
        }
        
        return fileData.length
      },
      videosNum() {
        var fileData = []
        if(this.$route.query.category) {
          fileData = this.dataList.filter((obj) => 
            (this.$route.query.category == 'Video' && obj.attributes.category == 'Video') && obj.attributes.link
          )
        }
        else {
          fileData = this.dataList.filter((obj) => 
            obj.attributes.category == 'Video' && obj.attributes.link
          )
        }

        if(this.searchInput) {
          fileData = this.totalData.filter((obj) => 
            obj.attributes.title == this.searchInput
          )
        }

        return fileData.length
      },
      relatedCategoryFiltered() {
        let filterCategory = []

        for(let x=0; this.relatedCategoryList.length > x; x++) {
          var ss = []
          if(this.searchInput) {
            ss = this.totalData.filter((obj) => 
              obj.attributes.category == this.relatedCategoryList[x].name
            )
          }
          else {
            ss = this.dataList.filter((obj) => 
              obj.attributes.category == this.relatedCategoryList[x].name
            )
          }
          if (ss.length > 0) {
            filterCategory.push({name: this.relatedCategoryList[x].name})
          }
        }

        return filterCategory
      }
    },
    methods:{
      downloadForm(link) {
        window.open(link)
      },
      async filterSubchildForms(name) {
        this.subFormActive = name
        this.isLoading = true 

        await this.$httpClientCMS({
          method: 'GET',
          url: 'api/my-resource-centres?populate=*&filters[category]=Forms&filters[subchildForms]=' + name +'&pagination[page]=1&pagination[pageSize]=5'
        })
        .then(resp => {
          let totalArr = resp.data.data
          this.data = totalArr
          this.totalData = totalArr
          this.totalDataLength =  resp.data.meta.pagination.total

          this.pagination = resp.data.meta.pagination
        })
        .catch((error) => {
          // this.$router.push('maintenance');
        });

        this.isLoading = false 
      },
      setTotalDataAndDataLength(filteredList){
        this.totalData = filteredList;
        this.totalDataLength = this.searchInput === '' ? this.pagination.total :  filteredList.length;
      },
      filterResourceCentre: debounce(function (type) {
        let filteredList = [];
        if(this.searchInput === ''){
          this.current = 1
          filteredList = this.$route.query.category ? this.data : this.totalDataAllCat;
        }
        else if(type === 'click'){
          filteredList = this.relatedCategoryList
        }
        else if(type === 'select'){
          filteredList = this.dataList.filter(i => i.attributes.title === this.searchInput);
        }else if(type === 'typing'){
          this.$set(this, 'categoryCurrent', '')
          const query = Object.assign({}, this.$route.query);
          if(query.category) {
            delete query.category;
            this.$router.replace({ query });
          }
          
          filteredList = this.dataList.filter((option) => {
            return option.attributes.title
              .toString()
              .toLowerCase()
              .indexOf(this.searchInput.toLowerCase()) >= 0
          })
        }
        this.setTotalDataAndDataLength(filteredList)
      }, 500)  ,
      async copyLink(mytext, k, category, id) {
        if(category == 'Weekly Review'){
          try {
            await navigator.clipboard.writeText('https://wealthpartners.aham.com.my/insights/weekly-market-review/' + id);
            this.copyIndex = k
            // this.latestTopicList[k].valueCopy = true
            setTimeout(() => this.copyIndex = null, 300)

          } catch($e) {

          }
        } 
        else if(category == 'Announcement'){
          try {
            await navigator.clipboard.writeText('https://wealthpartners.aham.com.my/consultant/my-resource-centre/announcement/' + id);
            this.copyIndex = k
            // this.latestTopicList[k].valueCopy = true
            setTimeout(() => this.copyIndex = null, 300)

          } catch($e) {

          }
        }
        else {

          try {
            await navigator.clipboard.writeText(mytext);
            this.copyIndex = k
            // this.latestTopicList[k].valueCopy = true
            setTimeout(() => this.copyIndex = null, 300)

          } catch($e) {

          }
        }
      },
      async sidebarHandler(type) {
        this.isLoading = true 
        this.subFormActive = ''
        this.current = 1
        this.categoryCurrent = type

        if(this.$route.query.category == type) {

        }
        else {
          this.$router.replace({ query: { category: type } })
        }

        this.isLoading = false 
        
      },
      async updateContentByPage(pageNum) {
        this.isLoading = true 
        await this.$httpClientCMS({
          method: 'GET',
          url: 'api/my-resource-centres?populate=*&sort=date:desc' + (this.$route.query.category ? ('&filters[category]=' + this.$route.query.category.replace('-', ' ')) : '' ) + '&pagination[page]=' + pageNum + '&pagination[pageSize]=5'
        })
        .then(resp => {
          this.isLoading = false
          window.scrollTo({
            top: 0, 
            behavior: 'smooth',
          });

          let totalArr = resp.data.data

          if(!this.$route.query.category) {
            this.totalDataAllCat = totalArr
          }

          this.data = totalArr
          this.totalData = totalArr
          this.totalDataLength = resp.data.meta.pagination.total

          this.pagination = resp.data.meta.pagination
        })
        .catch((error) => {
          this.isLoading = false
          // this.$router.push('maintenance');
        });
      },
      formatDate(apiDate){
        return dayjs(apiDate).format('DD MMM YYYY');
      },
    },
    watch:{
      $route (to, from){
          this.updateContentByPage(1)
      }
    } 
  }
</script>

<style scoped lang="scss">

.header-wrapper {
  margin-top: 1rem;
}

.content .count-wrap {
  align-items: center;
}

.sidebar-wrapper {
  text-align: left;
  .item-sidebar {
    padding: 0.5rem 0;
    cursor: pointer;
    &.active {
      font-weight: 600;
      color: #730039;
      text-decoration: 4px underline;
      text-underline-offset: 5px;
    }
  }
} 

.btn-download {
  &:focus {
    outline: none;
    box-shadow: none;
  }
}

.section {
  padding: 6rem 0 3rem;
}

.content {
  position: relative;
  display: block;
  width: 100%;
  min-height: 850px;
  background-color: #FFFFFF;
  padding: 2rem 5rem 3rem;
  text-align: left;
}

.tag-box {
  background-color: #37395A;
  padding: 0.5rem 1rem;
  margin-right: 0.5rem;
  margin-top: 0.5rem;
  font-weight: 600;
  color: #FFFFFF;
  &.active {
    border: 5px solid #3DBB95;
    padding: 0.28rem 1rem;
  }
}

.topic-card {
  display: flex;
  background-color: #F3F3F3;
  padding: 1.3rem;
  padding-right: 2.5rem;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  .pb-title {
    font-size: 1.25rem;
  }
}

:deep(){

  .mdi-link {
    rotate: -45deg !important;
  }
  .dropdown-content {
    background-color: white;
    text-align: left;
  }

  .control {
    input {
      background-color: #FFFFFF;
    }
  }
  
  @media screen and (max-width: 1023px){
    .control.has-icons-right .icon.is-right{
      height: -webkit-fill-available;
      margin-right: 30px;
    }
    
    .category-icon-list {
      position: absolute;
      top: 34%;
      right: 2%;
    }
    .control.has-icons-left .input, .icon.is-left {
      border-radius: 0 !important;
      font-weight: normal;
      font-size: inherit;
      color: #dbdbdb !important;
      padding-right: 20px !important;
    }

    .container {
      margin-left: 0;
      margin-right: 0;
      padding-left: 0;
      padding-right: 0;
    }

    .searchBar {
      margin: 0 0 50px !important;
    }

    .dropdown-category-mobile {
      background-color: #FFFFFF;
      padding: 1rem;
      position: absolute;
      width: 94%;
      margin: 0 3%;
      top: 50px;
      left: 0;
      box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.25);      
    }

    .pb-title {
      font-size: 24px;
      line-height: 28.8px; 
      margin-top: 0;
    }

    .header-wrapper {
      margin-top: 0;
    }

    .section.breadcrumb {
      padding: 50px 24px !important;
      white-space: normal;
    }

    .section {
      padding: 0 24px !important;
    }

    .content {
      padding: 2.25rem 1.5rem;
    }

    .topic-card {
      padding: 1rem 1.25rem;
    }

   

  }

  @media screen and (max-width: 768px){
    .control {
      padding-left: 0;
      padding-right: 0;
    }

    .content .count-wrap {
      justify-content: space-between;
    }

    .dropdown-category-mobile {
      width: 92%;
      margin: 0 4%;
    }

  }

  @media screen and (max-width: 500px){
    .category-icon-list {
      right: 4%;
    }
  }
}

</style>
